import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureEntitlements } from './featureEntitlements'
import { FeatureToggle } from './featureToggles'

// The Caper Reporting Dashboard has two ways to grant access (OR — access is
// granted if EITHER object matches):
//
// 1. Entitlement path: permission + the Caper feature entitlement. This path
//    respects the `CaperDashboardDisabledRetailers` per-retailer kill-switch — a
//    Roulette flag (keyed on `$.retailer_id`) that HIDES the dashboard from
//    specific retailers even when they have the entitlement.
//    `notWarehouseFeatureToggles` covers the warehouse-scope path;
//    `notFeatureToggles` also covers the account path in case the flag is set
//    account-wide.
//
// 2. Retailer override path: permission + the `IppCaperDashboardRetailer`
//    (`rt_ipp_caper_dashboard_retailer`) toggle. This force-shows the dashboard
//    for a retailer regardless of the Caper entitlement — and, because this
//    object deliberately omits the kill-switch, it OVERRIDES
//    `CaperDashboardDisabledRetailers` too (override wins).
export const insightsPortalCaperDashboardAccessControl: DomainAccessControlConfig = [
  {
    permissions: Permission.ViewCaperDashboard,
    featureEntitlementIds: [FeatureEntitlements.Caper],
    notWarehouseFeatureToggles: [FeatureToggle.CaperDashboardDisabledRetailers],
    notFeatureToggles: [FeatureToggle.CaperDashboardDisabledRetailers],
  },
  {
    permissions: Permission.ViewCaperDashboard,
    warehouseFeatureToggles: [FeatureToggle.IppCaperDashboardRetailer],
  },
]
